import React from "react";
import { overlayBase } from "./_shared";

interface Props {
  /** Flare colour (rgba), default warm white */
  color?: string;
  /** Travel cycle duration seconds, default 10 */
  dur?: number;
}

/**
 * LensFlare — bright radial glow spot drifting slowly across the frame.
 */
const LensFlare: React.FC<Props> = ({
  color = "rgba(255,250,220,0.65)",
  dur = 10,
}) => (
  <div style={overlayBase}>
    <style>{`
      @keyframes oot-flare {
        0%   { left: -10%; top: 15%; opacity: 0.3; }
        50%  { opacity: 0.75; }
        100% { left: 90%;  top: 35%; opacity: 0.3; }
      }
    `}</style>
    <div
      style={{
        position: "absolute",
        width: 140,
        height: 140,
        borderRadius: "50%",
        background: `radial-gradient(circle, ${color}, transparent 70%)`,
        filter: "blur(4px)",
        animation: `oot-flare ${dur}s ease-in-out infinite`,
      }}
    />
  </div>
);

export default LensFlare;
